import { Box, Grid, Typography } from "@mui/material";

const HomeText = ({hometext = null}) => {
  return (
    <Box>
      <Box width='100%' sx={{
        py: '1em',
        textAlign: 'center',
        px: '3em',
        backgroundColor: 'white'
      }}>
        <Typography variant="h2" sx={{
          fontWeight: 800,
          fontSize: '3em',
          pt: '1em',
          pb: '0.5em',
          lineHeight: '1.5em',
          color: '#800020'
        }}>
          {hometext ? hometext.note.split('\n\n')[0] : ''}
        </Typography>
        <Typography variant='h3' sx={{ lineHeight: '1.5em', py: '1em', whiteSpace: 'pre-line' }}>
          {hometext ? hometext.note.split('\n\n')[1] : ''}
        </Typography>
      </Box>
    </Box>
  );
};

export default HomeText;